module.exports = __webpack_public_path__ + "media/images/bread-star-icon-d19e3f0913e4e36e2a842a7c4d2d85e8.png";